/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type Defect_status = "ACCEPTED" | "IDENTIFIED" | "IN_REVIEW" | "REJECTED" | "RESOLVED" | "%future added value";
export type Severity = "CRITICAL" | "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type Submission_status = "COMPLETED" | "FAILED" | "PENDING" | "PROCESSING" | "%future added value";
export type SubmitAudioForInspectionInput = {
    inspectionId: string;
    videoFile: unknown;
    originalFilename?: string | null;
};
export type InspectionPanelSubmitAudioMutationVariables = {
    input: SubmitAudioForInspectionInput;
};
export type InspectionPanelSubmitAudioMutationResponse = {
    readonly submitAudioForInspection: {
        readonly audioSubmission: {
            readonly id: string;
            readonly videoURI: string;
            readonly originalFilename: string;
            readonly submissionStatus: Submission_status;
            readonly rawTranscript: string;
            readonly durationSeconds: number;
            readonly errorMessage: string;
        };
        readonly createdDefects: ReadonlyArray<{
            readonly id: string;
            readonly title: string;
            readonly description: string;
            readonly severity: Severity;
            readonly defectStatus: Defect_status;
            readonly roomType: string;
            readonly defectCategory: string;
            readonly aiDetected: boolean;
            readonly aiConfidence: number;
            readonly audioStartSeconds: number;
            readonly audioEndSeconds: number;
        }>;
    };
};
export type InspectionPanelSubmitAudioMutation = {
    readonly response: InspectionPanelSubmitAudioMutationResponse;
    readonly variables: InspectionPanelSubmitAudioMutationVariables;
};



/*
mutation InspectionPanelSubmitAudioMutation(
  $input: SubmitAudioForInspectionInput!
) {
  submitAudioForInspection(input: $input) {
    audioSubmission {
      id
      videoURI
      originalFilename
      submissionStatus
      rawTranscript
      durationSeconds
      errorMessage
    }
    createdDefects {
      id
      title
      description
      severity
      defectStatus
      roomType
      defectCategory
      aiDetected
      aiConfidence
      audioStartSeconds
      audioEndSeconds
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SubmitAudioForInspectionPayload",
    "kind": "LinkedField",
    "name": "submitAudioForInspection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "InspectionAudioSubmission",
        "kind": "LinkedField",
        "name": "audioSubmission",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "videoURI",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "originalFilename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submissionStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rawTranscript",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "durationSeconds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errorMessage",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefectItem",
        "kind": "LinkedField",
        "name": "createdDefects",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "severity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "defectStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "roomType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "defectCategory",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "aiDetected",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "aiConfidence",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "audioStartSeconds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "audioEndSeconds",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InspectionPanelSubmitAudioMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InspectionPanelSubmitAudioMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "5be69f634bc14444636d2d81d758c7f9",
    "id": null,
    "metadata": {},
    "name": "InspectionPanelSubmitAudioMutation",
    "operationKind": "mutation",
    "text": "mutation InspectionPanelSubmitAudioMutation(\n  $input: SubmitAudioForInspectionInput!\n) {\n  submitAudioForInspection(input: $input) {\n    audioSubmission {\n      id\n      videoURI\n      originalFilename\n      submissionStatus\n      rawTranscript\n      durationSeconds\n      errorMessage\n    }\n    createdDefects {\n      id\n      title\n      description\n      severity\n      defectStatus\n      roomType\n      defectCategory\n      aiDetected\n      aiConfidence\n      audioStartSeconds\n      audioEndSeconds\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'f73af826a90f10cde5df865ef45183a1';
export default node;
